<app-page-title [title]="pageTitle"></app-page-title>

<div class="form-container">
  <div class="header-actions">
    <button class="btn-secundary" [routerLink]="['/devocional']">Voltar</button>
  </div>

  <form [formGroup]="quizForm" (ngSubmit)="onSubmit()">
    <div class="card-form">
      <div class="form-section-title">Informações Básicas</div>

      <div class="row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Título do Quiz</mat-label>
          <input matInput formControlName="title" placeholder="Digite o título do devocional" />
          <mat-error *ngIf="quizForm.get('title').hasError('required')">O título é obrigatório</mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Data de Encerramento</mat-label>
          <input matInput type="date" formControlName="end_date" />
          <mat-error *ngIf="quizForm.get('end_date').hasError('required')"
            >A data de encerramento é obrigatória</mat-error
          >
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline" class="full-width text-area-field">
          <mat-label>Texto Base (Devocional)</mat-label>
          <textarea
            matInput
            formControlName="text"
            rows="8"
            placeholder="Cole o texto base do devocional aqui..."
          ></textarea>
          <mat-error *ngIf="quizForm.get('text').hasError('required')">O texto base é obrigatório</mat-error>
        </mat-form-field>
      </div>

      <div class="form-section-title mt-20">Perguntas</div>
      <p class="subtitle-hint">Você pode customizar as perguntas, mas o padrão será mantido caso você não altere.</p>

      <div class="row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Pergunta 1</mat-label>
          <input matInput formControlName="question_1" />
          <mat-error *ngIf="quizForm.get('question_1').hasError('required')">Este campo é obrigatório</mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Pergunta 2</mat-label>
          <input matInput formControlName="question_2" />
          <mat-error *ngIf="quizForm.get('question_2').hasError('required')">Este campo é obrigatório</mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Pergunta 3</mat-label>
          <input matInput formControlName="question_3" />
          <mat-error *ngIf="quizForm.get('question_3').hasError('required')">Este campo é obrigatório</mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Pergunta 4</mat-label>
          <input matInput formControlName="question_4" />
          <mat-error *ngIf="quizForm.get('question_4').hasError('required')">Este campo é obrigatório</mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Pergunta 5</mat-label>
          <input matInput formControlName="question_5" />
          <mat-error *ngIf="quizForm.get('question_5').hasError('required')">Este campo é obrigatório</mat-error>
        </mat-form-field>
      </div>

      <div class="form-actions">
        <button type="button" class="btn-secundary" [routerLink]="['/devocional']">Cancelar</button>
        <button type="submit" class="btn-primary" [disabled]="quizForm.invalid">
          {{ isEditMode ? 'Atualizar Quiz' : 'Salvar Quiz' }}
        </button>
      </div>
    </div>
  </form>
</div>
